<form [formGroup]="form" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px">
  @if (data()?.autocomplete) {
    @if (data()?.multiSelect) {
      <iot-platform-ui-async-autocomplete-multiple-selects
        (selectionChanged)="onSelectionChange($event)"
        [clearOnSelect]="true"
        [currentFilters]="currentFilters()"
        [criteriaKey]="$safeNavigationMigration(data()?.criteriaKey)"
        [data]="dynamicList()"
        [displayKey]="$safeNavigationMigration(data()?.selectByProperty)"
        [displaySearchIcon]="false"
        [displayWrapper]="$safeNavigationMigration(data()?.displayWrapper)"
        [filterKey]="data()?.skipAutoCompleteFilterCriteria ? null : $safeNavigationMigration(data()?.selectByProperty)"
        [filterBy]="$safeNavigationMigration(data()?.filterBy)"
        [minLength]="1"
        [multiSelect]="$safeNavigationMigration(data()?.multiSelect)"
        [placeholder]="$safeNavigationMigration(data()?.placeholder)"
        [showSpinner]="showLoader()"
        [disabled]="disabled()"
        [tooltip]="$safeNavigationMigration(data()?.tooltip)"
        [disableOnlyOptions]="true"
      />
    } @else {
      <iot-platform-ui-async-autocomplete
        [clearOnSelect]="true"
        (selectionChanged)="onSelectionChange($event)"
        [data]="dynamicList()"
        [displayKey]="$safeNavigationMigration(data()?.selectByProperty)"
        [displaySearchIcon]="false"
        [displayWrapper]="$safeNavigationMigration(data()?.displayWrapper)"
        [filterKey]="data()?.skipAutoCompleteFilterCriteria ? null : $safeNavigationMigration(data()?.selectByProperty)"
        [filterBy]="$safeNavigationMigration(data()?.filterBy)"
        [minLength]="1"
        [placeholder]="$safeNavigationMigration(data()?.placeholder)"
        [showSpinner]="showLoader()"
        [tooltip]="$safeNavigationMigration(data()?.tooltip)"
        [disabled]="disabled()"
      />
    }
  } @else {
    <div>
      <mat-form-field class="select-field" color="accent">
        <mat-label fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
          <span class="filter-label" fxFlex="90">{{ data()?.placeholder ?? data()?.criteriaLabel | translate }}</span>
          @if (showLoader()) {
            <mat-progress-spinner [diameter]="16" color="accent" fxFlex="10" mode="indeterminate" />
          }
        </mat-label>

        @if (data()?.multiSelect) {
          <mat-select
            (selectionChange)="onSelectionChange($safeNavigationMigration($event?.value))"
            multiple
            data-cy="iot-platform-ui-dynamic-list-field-single-select"
            formControlName="select"
          >
            @if (!showLoader()) {
              @for (option of dynamicList(); track $index) {
                <mat-option
                  [disabled]="!isSelectedOption(option) && disabled()"
                  [value]="option"
                  data-cy="iot-platform-ui-dynamic-list-field-single-select-option"
                  >{{ getOptionToDisplay(option) }}
                </mat-option>
              }
            }
          </mat-select>
        } @else {
          <mat-select
            (selectionChange)="onSelectionChange($safeNavigationMigration($event?.value))"
            data-cy="iot-platform-ui-dynamic-list-field-single-select"
            formControlName="select"
          >
            @if (!showLoader()) {
              @for (option of dynamicList(); track $index) {
                <mat-option
                  [disabled]="!isSelectedOption(option) && disabled()"
                  [value]="option"
                  data-cy="iot-platform-ui-dynamic-list-field-single-select-option"
                  >{{ getOptionToDisplay(option) }}
                </mat-option>
              }
            }
          </mat-select>
        }
      </mat-form-field>
    </div>
  }
</form>
